import React from 'react'
import { useTranslation } from 'react-i18next'
import CommonModal from 'jbc-front/components/CommonModal';
import Button from 'jbc-front/components/Button';
export default function ErrorModal({ errorInput, setOnCloseModal, onOpenModal }) {
    const { t } = useTranslation()

    return (
        <CommonModal hideModal={setOnCloseModal} isOpen={onOpenModal} ariaHideApp={false} id={'WarningModal'}>
            <CommonModal.Header hideModal={setOnCloseModal}>{t('features.PayrollRulesGroups.components.ErrorModal.Title')}</CommonModal.Header>
            <CommonModal.Body>
                <h2 style={{ color: 'red' }}>{t('features.PayrollRulesGroups.components.ErrorModal.Text')}</h2>
                {errorInput.map((e, index) => (
                    <h3 key={`error-${index + 1}`}>{index + 1}. {e}</h3>
                ))}
            </CommonModal.Body>
            <CommonModal.Footer>
                <CommonModal.Buttons>
                    <Button onClick={setOnCloseModal}>{t('features.PayrollRulesGroups.components.ErrorModal.CloseButton')}</Button>
                </CommonModal.Buttons>
            </CommonModal.Footer>
        </CommonModal>
    )
}
